import {nilObjectID} from "./nilObjectID";

export const isValidObjectID = (id: string | null | undefined): boolean =>
    !!id && id !== nilObjectID && /^[a-f0-9]{24}$/i.test(id);
